// extracted by mini-css-extract-plugin
var _1 = "input__NDp0Q";
export { _1 as "input" }
